import { useMutation } from '@apollo/client';

const useV2Mutation: typeof useMutation = (query, options, ...rest) => {
  return useMutation(
    query,
    {
      ...options,
      // @ts-expect-error - useV2 is a parameter defined in bk-web-app/graphqlClient
      context: {
        ...options?.context,
        useV2: true,
      },
    },
    ...rest,
  );
};

export default useV2Mutation;
